import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "pt-3"
}
const _hoisted_2 = { class: "row mt-4" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }

import { ref, watch } from "vue";
import { formatter } from "../../../shared/ts/formatter";
import FinalSalaryOption from "@/guiide/ts/assets/finalsalary/finalSalaryOption";
import FinalSalaryScheme from "@/guiide/ts/assets/finalsalary/finalSalaryScheme";
import SummaryRadioGroup from "../common/SummaryRadioGroup.vue";
import DBOptionsLumpSumChoices from "./DBOptionsLumpSumChoices.vue";
import BrightcoveVideoModal from "@/guiide/components/common/BrightcoveVideoModal.vue";
import { FinalSalaryOptionInfoStatic } from "@/guiide/ts/assets/finalsalary/finalSalaryOptionInfoStatic";
import FinalSalarySchemeOptionsDetail from "@/guiide/ts/response/finalSalarySchemeOptionsDetail";
import { useUIContent } from "@/guiide/ts/configuration/useUIContent";
import Help from "../common/Help.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OptionsSummary',
  props: {
    scheme: { type: Object as () => FinalSalaryScheme, required: true },
    optionsDynamic: { type: Object as () => FinalSalarySchemeOptionsDetail[], required: true },
    availableOptionsStatic: { type: Object as () => FinalSalaryOptionInfoStatic[], required: true }
},
  setup(__props) {

const props = __props;

const { templateTextArray, htmlArray } = useUIContent();

const taxFreeCashMax = ref(props.optionsDynamic.find(fsoi => fsoi.type == FinalSalaryOption.SchemeDefault)?.maxTaxFreeCash ?? 0);
const taxFreeCashAnnualIncome = ref(props.optionsDynamic.find(fsoi => fsoi.type == FinalSalaryOption.SchemeDefault)?.taxFreeCashAnnualIncome ?? 0);
const noTaxFreeCashAnnualIncome = ref(props.optionsDynamic.find(fsoi => fsoi.type == FinalSalaryOption.SchemeDefault)?.noTaxFreeCashAnnualIncome ?? 0);

const selectedSchemeOption = ref<FinalSalaryOption>(FinalSalaryOption.SchemeDefault);

watch(
    () => selectedSchemeOption.value,
    (newValue: FinalSalaryOption) => {
        const option = props.optionsDynamic.find(fsoi => fsoi.type == newValue);
        taxFreeCashMax.value = option.maxTaxFreeCash;
        taxFreeCashAnnualIncome.value = option.taxFreeCashAnnualIncome;
        noTaxFreeCashAnnualIncome.value = option.noTaxFreeCashAnnualIncome;
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templateTextArray)('dboptions.options.overview', { schemeName: __props.scheme.name }), (p, i) => {
      return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
    }), 128)),
    _createVNode(SummaryRadioGroup, {
      modelValue: selectedSchemeOption.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSchemeOption).value = $event)),
      options: __props.availableOptionsStatic
    }, {
      extraContent: _withCtx(({ selected }) => [
        (selectedSchemeOption.value === _unref(FinalSalaryOption).PensionIncreaseExchange)
          ? (_openBlock(), _createBlock(BrightcoveVideoModal, {
              key: 0,
              accountId: "1509269527",
              videoId: "6374435448112",
              linkText: "See how Pension Increase Exchange works in this video.",
              linkAriaLabel: "Open modal to watch video on Pension Increase Exchange",
              modalVideoAriaLabel: "You can watch this video to find out more about Pension Increase Exchange",
              modalTitle: "Pension Increase Exchange"
            }))
          : _createCommentVNode("", true),
        (selectedSchemeOption.value === _unref(FinalSalaryOption).PensionIncreaseExchange)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(Help, {
                title: "Pension Increase Exchange",
                text: _unref(htmlArray)('dboptions.options.pie.read-more.body'),
                linkText: "Read more about the PIE option."
              }, null, 8, ["text"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "options"]),
    _createElementVNode("div", _hoisted_2, [
      (selectedSchemeOption.value === _unref(FinalSalaryOption).SchemeDefault)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(DBOptionsLumpSumChoices, {
              taxFreeCashOption: { lumpSum: _unref(formatter).formatCurrency(taxFreeCashMax.value), annualIncome: _unref(formatter).formatCurrency(taxFreeCashAnnualIncome.value) },
              noTaxFreeCashOption: { lumpSum: '£0', annualIncome: _unref(formatter).formatCurrency(noTaxFreeCashAnnualIncome.value) }
            }, null, 8, ["taxFreeCashOption", "noTaxFreeCashOption"])
          ]))
        : (selectedSchemeOption.value === _unref(FinalSalaryOption).PensionIncreaseExchange)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(DBOptionsLumpSumChoices, {
                taxFreeCashOption: { lumpSum: _unref(formatter).formatCurrency(taxFreeCashMax.value), annualIncome: _unref(formatter).formatCurrency(taxFreeCashAnnualIncome.value) },
                noTaxFreeCashOption: { lumpSum: '£0', annualIncome: _unref(formatter).formatCurrency(noTaxFreeCashAnnualIncome.value) }
              }, null, 8, ["taxFreeCashOption", "noTaxFreeCashOption"])
            ]))
          : (selectedSchemeOption.value === _unref(FinalSalaryOption).BridgingPension)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(DBOptionsLumpSumChoices, {
                  taxFreeCashOption: { lumpSum: _unref(formatter).formatCurrency(taxFreeCashMax.value), annualIncome: _unref(formatter).formatCurrency(taxFreeCashAnnualIncome.value) },
                  noTaxFreeCashOption: { lumpSum: '£0', annualIncome: _unref(formatter).formatCurrency(noTaxFreeCashAnnualIncome.value) }
                }, null, 8, ["taxFreeCashOption", "noTaxFreeCashOption"])
              ]))
            : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})